import filterTypeEnum from "../../../../components/Filter/enumerations/filterTypeEnum";
import { filterKeyGameData } from "./filterKeyEnum";

const filterSetupGameData = {
  filter_type: 2,
  filters: [
    {
      type: filterTypeEnum.SELECT,
      title: "normal.type",
      data_type: "grouped",
      data_index: `${filterKeyGameData.CATEGORY_ID}-${filterKeyGameData.GAME_ID}`,
      items: [
        {
          title: "productReport.gameCategory",
          data_index: filterKeyGameData.CATEGORY_ID,
          type: filterTypeEnum.SELECT,
          columns: 4,
          required: true,
          data_type: "api",
        },
        {
          title: "productReport.gameSubCategory",
          data_index: filterKeyGameData.GAME_ID,
          type: filterTypeEnum.SELECT,
          columns: 4,
          required: true,
          data_type: "api",
        },
      ],
    },
    {
      title: "normal.time",
      type: filterTypeEnum.DATE_TIME_RANGE,
      data_index: [
        filterKeyGameData.SETTLED_AT_START,
        filterKeyGameData.SETTLED_AT_END,
      ],
      maxMonthInterval: 6,
      required: true,
    },
  ],
};

export { filterSetupGameData };
